import * as THREE from "three";

// Make a plane double-sided even if it doesn't have a double-sided material.
export class DoubleSidedPlaneGeometry extends THREE.PlaneGeometry {
  constructor(width: number, height: number, widthSegments?: number, heightSegments?: number) {
    super(width, height, widthSegments, heightSegments);
    // Make the plane double-sided.
    const positionAttribute = this.getAttribute("position") as THREE.BufferAttribute;
    const normalAttribute = this.getAttribute("normal") as THREE.BufferAttribute;
    const uvAttribute = this.getAttribute("uv") as THREE.BufferAttribute;
    const planeVertexCount = positionAttribute.count;
    const vertices = Array.from(positionAttribute.array);
    const normals = Array.from(normalAttribute.array);
    const uvs = Array.from(uvAttribute.array);
    // We can rely on this.index being defined since the PlaneGeometry constructor adds it.
    if (!(this.index !== null)) {
      console.assert(false);
    }
    const indices = Array.from((this.index as THREE.BufferAttribute).array);
    for (let i = 0; i < planeVertexCount; ++i) {
      vertices.push(-positionAttribute.array[i * 3]);
      vertices.push(positionAttribute.array[i * 3 + 1]);
      vertices.push(positionAttribute.array[i * 3 + 2]);
      normals.push(-normalAttribute.array[i * 3]);
      normals.push(-normalAttribute.array[i * 3 + 1]);
      normals.push(-normalAttribute.array[i * 3 + 2]);
      uvs.push(uvAttribute.array[i * 2]);
      uvs.push(uvAttribute.array[i * 2 + 1]);
    }
    for (let i = 0, l = (this.index as THREE.BufferAttribute).array.length; i < l; ++i) {
      indices.push(planeVertexCount + (this.index as THREE.BufferAttribute).array[i]);
    }
    this.setIndex(indices);
    this.setAttribute("position", new THREE.Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new THREE.Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new THREE.Float32BufferAttribute(uvs, 2));
  }
}
